import { useStore } from '../../StateProvider'
import React, { useState } from 'react'
import { registerTier3 } from '../api'
import { isEmpty } from 'ramda'
import { Tier3Form } from './Tier3Form'
import { useTranslation } from 'react-i18next'
import queryString from 'query-string'
import { useLocation } from 'react-router-dom'
import { Message } from '../../ui'

export const ErrorMessage = ({ message }) => {
  const [
    {
      whitelabel: { phone }
    }
  ] = useStore()
  const { t } = useTranslation()
  return (
    <Message title={t('tier3Upgrade.submitError')} type='failed'>
      {message} <br />
      {t('tier3Upgrade.submitErrorTxt1')}
      {phone} {t('tier3Upgrade.submitErrorTxt2')}
    </Message>
  )
}

const Tier3Register = () => {
  const [isSent, setIsSent] = useState(false)
  const [sendError, setSendError] = useState({})
  const { t } = useTranslation()
  const location = useLocation()

  const onSubmit = (formData) => {
    const { dept_code: deptCode } = queryString.parse(location.search)
    formData = deptCode ? { ...formData, deptCode } : formData
    const resolve = () => {
      setIsSent(true)
      setSendError({})
    }
    /**
     * @param {ErrorCommon} error
     */
    const reject = (error) => {
      setIsSent(false)
      setSendError(error)
    }
    return registerTier3(formData).then(resolve, reject)
  }

  if (!isEmpty(sendError)) {
    return <ErrorMessage message={sendError.message} />
  }
  if (isSent) {
    return (
      <Message title={t('tier3Upgrade.sentHeader')} type='clock'>
        {t('tier3Upgrade.sentText')}
      </Message>
    )
  } else {
    return (<Tier3Form onSent={onSubmit} />)
  }
}

export { Tier3Register }
